import { tv, type VariantProps } from "tailwind-variants"
import { classNames } from "../../utils"
import { borderVariants } from "./border"
import { buttonLayoutVariants } from "./buttonLayout"
import { disabledVariants } from "./disabled"

export type InputVariantProps = VariantProps<typeof inputVariants>

export const inputVariants = tv({
  extend: buttonLayoutVariants,
  base: "w-full text-md placeholder:text-text-secondary ",
  variants: {
    variant: {
      default: classNames(
        "bg-bg-primary hover:bg-bg-secondary",
        borderVariants({ border: "border-1" }),
      ),
      transparent: classNames(
        "bg-bg-primary-transparent hover:bg-bg-secondary-transparent-hover",
        borderVariants({ border: "border-1", transparent: true }),
      ),
      ghost: "px-0",
    },
    disabled: {
      true: disabledVariants({ disabled: true }),
    },
    error: {
      true: "border-error",
    },
    warning: {
      true: "border-warning",
    },
  },
  defaultVariants: {
    variant: "default",
  },
  // Placed in compound variants for precedence
  compoundVariants: [
    { variant: "ghost", class: "px-0" },
    {
      variant: "ghost",
      error: true,
      class: "text-error [&_input]:placeholder:text-error",
    },
    {
      warning: true,
      error: true,
      class: "border-error",
    },
  ],
})
